/**
 * Baiia Fit Guide — section script
 * Scoped per-instance via [data-fit-guide] so nothing breaks
 * if this section is ever used more than once on a page.
 */
(function () {
  function initFitGuide(root) {
    const sizeData = JSON.parse(root.querySelector('[data-fg-size-json]').textContent);
    const customerProof = JSON.parse(root.querySelector('[data-fg-proof-json]').textContent);
    const shopLinks = JSON.parse(root.querySelector('[data-fg-links-json]').textContent);

    let currentUnit = 'cm';
    let currentStep = 1;
    let fitType = null;
    let styleType = null;
    let tableUnit = 'cm';

    const $ = (sel, ctx) => (ctx || root).querySelector(sel);
    const $$ = (sel, ctx) => Array.from((ctx || root).querySelectorAll(sel));

    /* ---------- Tabs ---------- */
    $$('[data-fg-tab-btn]').forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.getAttribute('data-fg-tab-btn');
        $$('[data-fg-panel]').forEach(p => p.classList.remove('active'));
        $$('[data-fg-tab-btn]').forEach(b => b.classList.remove('active'));
        $(`[data-fg-panel="${tab}"]`).classList.add('active');
        btn.classList.add('active');
      });
    });

    function goToTab(tab) {
      $(`[data-fg-tab-btn="${tab}"]`)?.click();
    }
    root.querySelectorAll('[data-fg-goto-tab]').forEach(el => {
      el.addEventListener('click', () => goToTab(el.getAttribute('data-fg-goto-tab')));
    });

    /* ---------- Unit toggle (finder) ---------- */
    $$('[data-fg-unit]').forEach(btn => {
      btn.addEventListener('click', () => setUnit(btn.getAttribute('data-fg-unit')));
    });
    function setUnit(unit) {
      currentUnit = unit;
      $$('[data-fg-unit]').forEach(b => b.classList.toggle('active', b.getAttribute('data-fg-unit') === unit));
      ['bust', 'underbust', 'waist'].forEach(m => {
        const unitLabel = $(`[data-fg-unit-label="${m}"]`);
        if (unitLabel) unitLabel.textContent = unit;
        const input = $(`[data-fg-input="${m}"]`);
        if (input) {
          input.placeholder = unit === 'cm'
            ? (m === 'bust' ? 'e.g. 96' : m === 'underbust' ? 'e.g. 80' : 'e.g. 74')
            : (m === 'bust' ? 'e.g. 38' : m === 'underbust' ? 'e.g. 31' : 'e.g. 29');
        }
      });
    }

    /* ---------- Step 1: measurements ---------- */
    $$('[data-fg-input]').forEach(input => {
      input.addEventListener('input', () => {
        input.classList.toggle('has-value', input.value.length > 0);
        const bust = $('[data-fg-input="bust"]').value;
        const underbust = $('[data-fg-input="underbust"]').value;
        const waist = $('[data-fg-input="waist"]').value;
        $('[data-fg-step-next="1"]').disabled = !(bust && underbust && waist);
      });
    });

    /* ---------- Step 2: fit preference ---------- */
    $$('[data-fg-fit-type]').forEach(card => {
      card.addEventListener('click', () => {
        $$('[data-fg-fit-type]').forEach(c => c.classList.remove('selected'));
        card.classList.add('selected');
        fitType = card.getAttribute('data-fg-fit-type');
        $('[data-fg-step-next="2"]').disabled = false;
      });
    });

    /* ---------- Step 3: category ---------- */
    $$('[data-fg-style-type]').forEach(card => {
      card.addEventListener('click', () => {
        $$('[data-fg-style-type]').forEach(c => c.classList.remove('selected'));
        card.classList.add('selected');
        styleType = card.getAttribute('data-fg-style-type');
        $('[data-fg-step-next="3"]').disabled = false;
      });
    });

    /* ---------- Step navigation ---------- */
    $$('[data-fg-goto-step]').forEach(btn => {
      btn.addEventListener('click', () => goToStep(parseInt(btn.getAttribute('data-fg-goto-step'), 10)));
    });

    function goToStep(step) {
      $(`[data-fg-step-card="${currentStep}"]`).classList.remove('active');
      $(`[data-fg-dot="${currentStep}"]`).classList.remove('active');
      $(`[data-fg-dot="${currentStep}"]`).classList.add('done');
      if (currentStep < step) {
        const line = $(`[data-fg-line="${currentStep}"]`);
        if (line) line.classList.add('done');
      }
      currentStep = step;
      $(`[data-fg-step-card="${step}"]`).classList.add('active');
      $(`[data-fg-dot="${step}"]`).classList.remove('done');
      $(`[data-fg-dot="${step}"]`).classList.add('active');
    }

    /* ---------- Result ---------- */
    const findBtn = $('[data-fg-step-next="3"]');
    if (findBtn) findBtn.addEventListener('click', showResult);

    function showResult() {
      const bustVal = parseFloat($('[data-fg-input="bust"]').value);
      const underVal = parseFloat($('[data-fg-input="underbust"]').value);
      const waistVal = parseFloat($('[data-fg-input="waist"]').value);
      const bustCm = currentUnit === 'in' ? bustVal * 2.54 : bustVal;
      const underCm = currentUnit === 'in' ? underVal * 2.54 : underVal;
      const waistCm = currentUnit === 'in' ? waistVal * 2.54 : waistVal;

      let bestSize = sizeData[0];
      let nextSize = null;

      for (let i = 0; i < sizeData.length; i++) {
        const s = sizeData[i];
        if (bustCm >= s.bustCm[0] && bustCm <= s.bustCm[1]) {
          bestSize = s;
          nextSize = sizeData[i + 1] || null;
          break;
        }
        if (bustCm > s.bustCm[1] && i === sizeData.length - 1) bestSize = s;
      }

      let recommendedSize = bestSize;
      if (fitType === 'size-up' && nextSize) recommendedSize = nextSize;

      $(`[data-fg-step-card="3"]`).classList.remove('active');
      $(`[data-fg-dot="3"]`).classList.remove('active');
      $(`[data-fg-dot="3"]`).classList.add('done');
      $(`[data-fg-line="2"]`).classList.add('done');

      const rc = $('[data-fg-result-card]');
      rc.classList.add('show');
      $('[data-fg-result-size]').textContent = recommendedSize.au;
      $('[data-fg-result-size-intl]').textContent = recommendedSize.us;

      const du = currentUnit;
      $('[data-fg-result-bust]').textContent = du === 'cm' ? bustCm.toFixed(0) + ' cm' : bustVal.toFixed(1) + ' in';
      $('[data-fg-result-underbust]').textContent = du === 'cm' ? underCm.toFixed(0) + ' cm' : underVal.toFixed(1) + ' in';
      $('[data-fg-result-waist]').textContent = du === 'cm' ? waistCm.toFixed(0) + ' cm' : waistVal.toFixed(1) + ' in';
      $('[data-fg-result-note]').innerHTML = `Based on your measurements, <strong>${recommendedSize.au}</strong> is your ideal fit. This style will feel firm at first - that's by design. It softens beautifully with wear and water.`;



      const proofList = $('[data-fg-proof-list]');
      proofList.innerHTML = '';

      const shopBtn = $('[data-fg-result-shop-btn]');
      shopBtn.textContent = `Shop ${recommendedSize.au} / ${recommendedSize.us}`;

      // If inside a product page modal, close it and select the size pill instead of linking away.
      const parentModal = root.closest('modal-dialog[id^="FindMySizeModal"]');
      if (parentModal) {
        shopBtn.removeAttribute('href');
        shopBtn.onclick = function () {
          parentModal.hide ? parentModal.hide() : parentModal.removeAttribute('open');
          const allPills = document.querySelectorAll('.product-form__input--pill input[type="radio"]');
          const auNumber = recommendedSize.au.replace('AU ', '');
          allPills.forEach(pill => {
            if (pill.value === auNumber) {
              pill.click();
            }
          });
        };
      } else {
        shopBtn.onclick = null;
        const link = shopLinks[styleType] || shopLinks['all'] || '#';
        shopBtn.setAttribute('href', link);
      }
    }

    /* ---------- Reset ---------- */
    $$('[data-fg-redo]').forEach(btn => btn.addEventListener('click', resetFinder));
    function resetFinder() {
      $('[data-fg-result-card]').classList.remove('show');
      $$('[data-fg-step-card]').forEach(s => s.classList.remove('active'));
      $$('[data-fg-dot]').forEach(d => d.classList.remove('active', 'done'));
      $$('[data-fg-line]').forEach(l => l.classList.remove('done'));
      $$('[data-fg-fit-type], [data-fg-style-type]').forEach(c => c.classList.remove('selected'));
      ['bust', 'underbust', 'waist'].forEach(m => {
        const input = $(`[data-fg-input="${m}"]`);
        input.value = '';
        input.classList.remove('has-value');
      });
      $('[data-fg-step-next="1"]').disabled = true;
      $('[data-fg-step-next="2"]').disabled = true;
      $('[data-fg-step-next="3"]').disabled = true;
      currentStep = 1; fitType = null; styleType = null;
      $('[data-fg-step-card="1"]').classList.add('active');
      $('[data-fg-dot="1"]').classList.add('active');
    }

    /* ---------- Size chart table ---------- */
    function cmToIn(cm) { return (cm / 2.54).toFixed(1); }
    function renderTable() {
      const tbody = $('[data-fg-table-body]');
      if (!tbody) return;
      tbody.innerHTML = sizeData.map(s => {
        const bust = tableUnit === 'cm' ? `${s.bustCm[0]}–${s.bustCm[1]} cm` : `${cmToIn(s.bustCm[0])}–${cmToIn(s.bustCm[1])} in`;
        const waist = tableUnit === 'cm' ? `${s.waistCm[0]}–${s.waistCm[1]} cm` : `${cmToIn(s.waistCm[0])}–${cmToIn(s.waistCm[1])} in`;
        const hips = tableUnit === 'cm' ? `${s.hipsCm[0]}–${s.hipsCm[1]} cm` : `${cmToIn(s.hipsCm[0])}–${cmToIn(s.hipsCm[1])} in`;
        return `<tr><td>${s.au} / ${s.us}</td><td>${bust}</td><td>${waist}</td><td>${hips}</td></tr>`;
      }).join('');
    }
    $$('[data-fg-table-unit]').forEach(btn => {
      btn.addEventListener('click', () => {
        tableUnit = btn.getAttribute('data-fg-table-unit');
        $$('[data-fg-table-unit]').forEach(b => b.classList.toggle('active', b.getAttribute('data-fg-table-unit') === tableUnit));
        renderTable();
      });
    });
    renderTable();

    /* ---------- Video placeholders ----------
       Replace this with real video embeds / a modal
       once you have hosted video URLs (see README). */
    function getVideoEmbedUrl(url) {
      if (!url) return null;
      const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
      if (yt) return `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0`;
      const vimeo = url.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
      if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1`;
      return null;
    }

    const videoModal = $('[data-fg-video-modal]');
    const videoModalPlayer = $('[data-fg-video-modal-player]');

    function openVideoModal(url) {
      const embedUrl = getVideoEmbedUrl(url);
      if (!embedUrl) {
        alert('Add a valid YouTube or Vimeo URL in the section settings for this clip.');
        return;
      }
      videoModalPlayer.innerHTML = `<iframe src="${embedUrl}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
      videoModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeVideoModal() {
      videoModal.classList.remove('active');
      videoModalPlayer.innerHTML = '';
      document.body.style.overflow = '';
    }

    $$('[data-fg-video-trigger]').forEach(card => {
      card.addEventListener('click', () => openVideoModal(card.getAttribute('data-fg-video-url')));
    });

    $$('[data-fg-video-modal-close]').forEach(el => {
      el.addEventListener('click', closeVideoModal);
    });

    if (videoModal) {
      document.body.appendChild(videoModal);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-fit-guide]').forEach(initFitGuide);
  });
  // Shopify theme editor: re-init if section is reloaded in the customizer.
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector ? e.target.querySelector('[data-fit-guide]') : null;
    if (root) initFitGuide(root);
  });
})();
